import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appInputDecimalThreeDigits]'
})
export class AppInputDecimalThreeDigitsDirective {

  constructor(private element: ElementRef) { }

  @HostListener('keypress', ['$event']) onKeyPress(): boolean {

    const long: number = this.element.nativeElement.value.length;
    if (long > 3) {
      return false;
    }
  }

@HostListener('change', ['$event']) onChange(): void {

    const valorInicial: number = this.element.nativeElement.value;
    let valorFinal = 0.0;
    if (valorInicial > 99.9) {
      valorFinal = 99.9;
    } else {
      if (valorInicial < 0) {
        valorFinal = 0;
      } else {
        valorFinal = valorInicial;
      }
    }
    this.element.nativeElement.value = valorFinal;
  }
}
